import Vue from "vue";
import Vuex from "vuex";

import { account } from "./account.module";
import { alert } from "./alert.module";
import { asset } from "./asset.module";
import { map } from "./map.module";
import { navigation } from "./navigation.module";
import { pwa } from "./pwa.module";

Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    account,
    alert,
    asset,
    map,
    navigation,
    pwa,
  },
});
